/**
 * Converts the empty `<span data-kvariable="name"></span>` elements emitted by
 * the editor's VariableNode back into the plain `{{name}}` template token.
 *
 * The body editor stores HTML via `getHTML()`, but the backend (and every send
 * site) expects literal `{{name}}` tokens. Running this at the editor boundary
 * keeps `formik.values.body` in the canonical `{{name}}` format, so none of the
 * downstream consumers change. Mirrors `surveyFormatter.replaceSurveySpanWithPlaceholder`.
 *
 * @param {string} htmlString - Editor HTML possibly containing variable spans.
 * @returns {string} HTML with variable spans replaced by `{{name}}` tokens.
 */
export const serializeVariables = (htmlString) => {
  return (
    htmlString?.replace(
      /<span[^>]*data-kvariable=["']([^"']+)["'][^>]*><\/span>/gi,
      '{{$1}}'
    ) || ''
  );
};
